<template>
  <div class="station-card">
    <div class="info">
      <div><b>{{ station.name }}</b></div>
      <div>{{ station.address }}</div>
    </div>
    <div class="actions">
      <FontAwesomeIcon icon="phone" class="action" :class="callable ? '' : 'disabled'" @click="callStation" />
      <FontAwesomeIcon icon="directions" class="action" :class="navigatable ? '' : 'disabled'" @click="navigateToStation" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'station-card',
    props: {
      station: {
        type: Object,
        required: true,
      },
    },
    methods: {
      callStation() {
        if (!this.callable) return;
        window.open(`tel:${this.station.phoneNumber}`, '_system');
      },
      navigateToStation() {
        if (!this.navigatable) return;
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${this.station.location.coordinates[1]},${this.station.location.coordinates[0]}`);
      },
    },
    computed: {
      callable() {
        return !!this.station.phoneNumber;
      },
      navigatable() {
        return !!this.station.location && !!this.station.location.coordinates && this.station.location.coordinates.length === 2;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .station-card {
    background-color: var(--color-background);
    border-radius: 2em;

    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 1em;
  }

  .actions {
    color: var(--color-primary);
    font-size: 1.5em;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;

    margin-right: -0.5em;
    margin-bottom: -0.5em;

    & > * {
      margin-right: 0.5em;
      margin-bottom: 0.5em;
    }
  }

  .action {
    cursor: pointer;
  }

  .disabled {
    color: var(--color-disabled);
  }
</style>
